{
  "dropzoneLabel": "放置区域",
  "selectPlaceholder": "选择一个项目",
  "tableResizer": "尺寸调整器",
  "colorSwatchPicker": "Color swatches"
}
